import moment from 'moment'
import examLink from './examLink.vue'
import examButton from './examButton.vue'
export default {
  methods: {
    formatScore (score) {
      if (!score) {
        return '0.0'
      }
      return (Math.round(score * 100) / 100).toFixed(1)
    },
    formatDuration (time) {
      if (!time) {
        return '-'
      }
      let days = Math.floor(time / (60 * 24))
      let hours = Math.floor(time % (60 * 24) / 60)
      let minutes = time % 60
      return (days && days + '天' || '') + (hours && hours + '小时' || '') + (minutes + '分')
    },
    formatTime (time) {
      if (new Date('2000/01/01 00:00:00').getTime() > time) {
        return '~'
      }
      return moment(time).format('YYYY-MM-DD HH:mm')
    },
    deadlineTimeout (item) {
      if (Date.now() > item && item > new Date('2000/01/01 00:00:00').getTime()) {
        return true
      }
      return false
    }
  },
  components: {
    examLink,
    examButton
  }
}